"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SOURCE_MAP_ENDPOINT = void 0;
exports.SOURCE_MAP_ENDPOINT = '/source-map-helper.wasm';
